import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Project } from '@wilson/interfaces';
import {
  FetchAndAddProjectIfNotInState,
  ProjectsState,
} from '@wilson/projects/state';
import { Observable, filter, of, switchMap } from 'rxjs';

@Pipe({
  name: 'getProjectById',
  standalone: true,
})
export class GetProjectByIdPipe implements PipeTransform {
  private readonly store = inject(Store);

  transform(id: string | null | undefined): Observable<Project | undefined> {
    if (!id) {
      return of(undefined);
    }

    return this.store.dispatch(new FetchAndAddProjectIfNotInState(id)).pipe(
      switchMap(() => this.store.select(ProjectsState.projectById(id))),
      filter((project) => !!project),
    );
  }
}
